'use strict';

exports.__esModule = true;

exports.default = function () {
  return typeof __webpack_nonce__ !== 'undefined' ? __webpack_nonce__ : null;
};
/* eslint-disable camelcase, no-undef */

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/styled-components/lib/utils/nonce.js
// module id = 227
// module chunks = 168707334958949